import './others.ts';

import { LarchSys } from './utils/larchSys';
import { sliderFeature } from './app/slider';
import { objectFitFeature } from './app/objectFit';
import { gotoLinkFeature } from './app/gotoLink';
import { lazysizesFeature } from './app/lazysizes';
import { cookieConsentFeature } from './app/cookieconsent';
import { fancyboxFeature } from './app/fancybox';
import { marqueeFeature } from './app/marquee';
import { newsletterPopupFeature } from './app/newsletterPopup';

import { navbarBlock } from './app/modules/navbar';
import { projectsBlock } from './app/modules/projectsblock';
import { crossesBlock } from './app/modules/crosses';
import { newsletterBlock } from './app/modules/newsletterblock';


const larchSys = new LarchSys();


larchSys.load([
    sliderFeature,
    objectFitFeature,
    gotoLinkFeature,

    lazysizesFeature,
    cookieConsentFeature,
    fancyboxFeature,
    marqueeFeature,

    newsletterPopupFeature,
    newsletterBlock,

    navbarBlock,
    projectsBlock,
    crossesBlock,
]);


// export global
Object.assign(global, { larchSys });
